(function(){
'use strict';
function init(){

/* ---------- Produktdaten: Preise und Varianten kommen live aus der Kollektion "produktberater" ---------- */
const PRODUCTS = {
  padS:       {name:'MagUp-Pad S (2er-Set)', v:{schwarz:'magup-pad-s-schwarz', weiss:'magup-pad-s-weiss'}},
  padM:       {name:'MagUp-Pad M (2er-Set)', v:{schwarz:'magup-pad-m-schwarz', weiss:'magup-pad-m-weiss'}},
  bundle2:    {name:'Bundle 2x Flexigel Untersetzer & MagUp-Pads S', v:{schwarz:'bundle-2x-flexigel-untersetzer-magup-pads-s-schwarz', weiss:'bundle-2x-flexigel-untersetzer-magup-pads-s-weiss'}},
  bundle1:    {name:'Bundle 1x Flexigel Untersetzer & MagUp-Pads S', v:{schwarz:'bundle-1x-flexigel-untersetzer-magup-pads-s-schwarz', weiss:'bundle-1x-flexigel-untersetzer-magup-pads-s-weiss'}},
  untersetzer:{name:'Flexigel-Untersetzer (eckig)', v:{schwarz:'flexigel-pads-eckig-schwarz', weiss:'flexigel-pads-eckig-weiss'}},
  metall25:   {name:'Metall-Leiste 25 cm (mit 3M VHB™ Kleberückseite)', v:{schwarz:'metall-leiste-25-cm-black', weiss:'metall-leiste-25-cm-white'}},
  metall50:   {name:'Metall-Leiste 50 cm (mit 3M VHB™ Kleberückseite)', v:{schwarz:'metall-leiste-50-black', weiss:'metall-leiste-50cm-white'}},
  flex26:     {name:'Flexigel-Leiste 26 cm', v:{schwarz:'flexigel-leiste-25-cm-black', weiss:'flexigel-leiste-25-cm-white'}},
  flex51:     {name:'Flexigel-Leiste 51 cm', v:{schwarz:'flexigel-leiste-50-cm-black', weiss:'flexigel-leiste-50-cm-white'}},
  platzset:   {name:'Flexigel-Platzset', v:{schwarz:'flexigel-platzset-schwarz', weiss:'flexigel-platzset-weiss'}},
  stapelset:  {name:'MagUp Stapelset (3 Stapelpads)', v:{schwarz:'magup-stapelset'}, fixed:true},
  angles:     {name:'Angles Morts Flexigel-Pad (3er-Set)', v:{schwarz:'angles-morts-flexigel-pad-3er-set'}, fixed:true},
  garderobe:  {name:'Garderobe »Hold On« inkl. Flexigel-Leiste', v:{schwarz:'garderobenset'}},
  haken:      {name:'Magnet-Haken »Hold On« inkl. Flexigel-Pad', v:{schwarz:'magnet-haken-hold-on-inkl-pad-black'}},
  kuechenrolle:{name:'Magnet-Küchenrollenhalter inkl. Metall-Leiste', v:{schwarz:'magnet-kuchenrollenhalter-inkl-metallleiste-schwarz'}},
  toilette:   {name:'Magnet-Toilettenrollenhalter inkl. Metall-Leiste', v:{schwarz:'magnet-toilettenrollenhalter-inklusive-metall-leiste-schwarz'}},
  leuchte:    {name:'Design-Tischleuchte inkl. MagUp-Pad S', v:{schwarz:'design-tischleuchte-anthrazit-inklusive-magup-pad-s-schwarz', weiss:'design-tischleuchte-weiss-inklusive-magup-pad-s-weiss'}, label:{schwarz:'anthrazit', weiss:'weiß'}},
  spot:       {name:'Magnet Leucht-Spot inkl. Flexigel-Pad L', v:{schwarz:'magnet-leucht-spot-schwarz-inklusive-flexigel-pad-l-o-8-3-cm-schwarz'}},
  magspike:   {name:'Flexigel-Leiste & MagSpike® Set (2 MagSpikes)', v:{schwarz:'flexigel-magspike-bundle-black'}, fixed:true},
  refillduo:  {name:'Magnet-RefillDuo inkl. Flexigel-Leiste und 2 Nachfüllflaschen (je 250 ml)', v:{schwarz:'magnet-refillduo-inkl-flexigel-leiste-mit-magneten'}, fixed:true},
  pins:       {name:'Magnet-Pins inkl. Pads S (4er-Set)', v:{schwarz:'magnet-pins-edel-inkl-pads-black', weiss:'magnet-pins-classic-inkl-pads-white'}, label:{schwarz:'»EDEL« silber, Pads schwarz', weiss:'»CLASSIC« weiß, Pads weiß'}},
  schluessel: {name:'Magnet-Schlüsselringe silber inkl. Pads S (3er-Set)', v:{schwarz:'magnet-schluesselring-silber-pad-schwarz', weiss:'magnet-schluesselring-silber-pad-weiss'}}
};
const ROOT = document.getElementById('gm-berater');
const CFG = (()=>{ try{ return JSON.parse(document.getElementById('gm-berater-data').textContent); }catch(e){ return {products:{}}; } })();
const DATA = CFG.products || {};
const DEBUG = /[?&]debug=1/.test(location.search);
for(const [key,p] of Object.entries(PRODUCTS)){
  for(const c of Object.keys(p.v)){ if(!DATA[p.v[c]]) delete p.v[c]; }
  if(!Object.keys(p.v).length) delete PRODUCTS[key];
}
const exists = key => !!PRODUCTS[key];
const colorOf = key => { const c=(ans('farbe')||'schwarz'); return PRODUCTS[key].v[c] ? c : 'schwarz'; };
const handleOf = key => PRODUCTS[key].v[colorOf(key)] || Object.values(PRODUCTS[key].v)[0];
const priceOf = key => (DATA[handleOf(key)].price||0)/100;
const variantOf = key => DATA[handleOf(key)].id;

/* ---------- Antworten ---------- */
let A = {};
let history = [];
let cur = 'bereich';
let lines = [];
let lead = {kontakt:'video'};
let leadSent = false;

const has = (id,v) => Array.isArray(A[id]) && A[id].includes(v);
const care = () => A.bereich==='care';
const zh = () => A.bereich==='zuhause';
const zr = v => zh() && has('zhRaeume', v);
const zi = (id,v) => has(id, v);
const hasG = () => !care() && (A.ziel==='geschirr' || A.ziel==='beides');
const hasH = () => !care() && (A.ziel==='haengen' || A.ziel==='beides');
const einr = () => care() && A.careFuer==='einrichtung';
const sit = v => care() && has('careSituation', v);
const gt = () => has('geschirr','glaeser') || has('geschirr','tassen');
const P = () => Number(A.personen||1);
const gtCount = () => (has('geschirr','glaeser')?P():0) + (has('geschirr','tassen')?P():0);
const units = () => Math.ceil(gtCount()/4);

const PERS = ['Alleine','Zu zweit','Zu dritt','Zu viert','Zu fünft','Zu sechst'];

const STEPS = [
  {id:'bereich', q:'Wofür möchtest du gelmags® einsetzen?', opts:[
    {v:'camping', l:'Camping', d:'Wohnwagen, Wohnmobil oder Camper'},
    {v:'boot', l:'Boot', d:'Segelboot, Motorboot oder Hausboot'},
    {v:'care', l:'Care', d:'Mehr Sicherheit beim Essen und Trinken'},
    {v:'zuhause', l:'Zuhause', d:'Küche, Bad, Flur, Wohnbereich'}]},
  {id:'fahrzeug', when:()=>A.bereich==='camping', q:'Womit bist du unterwegs?', opts:[
    {v:'wohnwagen', l:'Wohnwagen'},
    {v:'wohnmobil', l:'Wohnmobil'},
    {v:'camper', l:'Camper', d:'Kastenwagen oder Van'}]},
  {id:'bootstyp', when:()=>A.bereich==='boot', q:'Welches Boot fährst du?', opts:[
    {v:'segelboot', l:'Segelboot'},
    {v:'motorboot', l:'Motorboot'},
    {v:'hausboot', l:'Hausboot oder Charterboot'}]},
  {id:'masse', when:()=>A.bereich==='camping' && ['wohnmobil','camper'].includes(A.fahrzeug),
    q:'Wie hoch ist die zulässige Gesamtmasse deines Fahrzeugs?',
    hint:'Du findest den Wert im Fahrzeugschein unter F.2.', opts:[
    {v:'bis35', l:'Bis 3,5 t'},
    {v:'ueber35', l:'Über 3,5 t'},
    {v:'unklar', l:'Weiß ich nicht'}]},
  {id:'personen', grid:true, when:()=>['camping','boot'].includes(A.bereich), q:'Wie viele Personen reisen in der Regel mit?',
    opts:PERS.map((l,i)=>({v:String(i+1), l:String(i+1), d:l}))},
  {id:'ziel', when:()=>['camping','boot'].includes(A.bereich), q:'Was möchtest du sichern?', opts:[
    {v:'geschirr', l:'Geschirr', d:'Gläser, Tassen, Teller, Bowls, Pfannen'},
    {v:'haengen', l:'Etwas aufhängen', d:'Jacken, Handtücher, Rollen, Licht'},
    {v:'beides', l:'Beides', d:'Geschirr sichern und etwas aufhängen'}]},
  {id:'magnetgeschirr', when:hasG, q:'Hast du schon Geschirr mit Magneten?', opts:[
    {v:'nachruesten', l:'Nein, ich möchte mein Geschirr nachrüsten', d:'Du nutzt dein vorhandenes Geschirr weiter.'},
    {v:'vorhanden', l:'Ja, ich habe bereits Magnetgeschirr', d:'Du brauchst nur noch die passende Gegenseite.'}]},
  {id:'geschirr', multi:true, when:hasG, q:'Welches Geschirr soll während der Fahrt sicher bleiben?', hint:'Mehrfachauswahl möglich.', opts:[
    {v:'glaeser', l:'Gläser'},
    {v:'tassen', l:'Tassen und Becher'},
    {v:'teller', l:'Teller'},
    {v:'bowls', l:'Bowls und Schüsseln'},
    {v:'pfannen', l:'Pfannen und Töpfe'}]},
  {id:'kopfueber', when:()=>hasG() && gt(), q:'Sollen Gläser und Tassen kopfüber hängen?', hint:'Zum Beispiel unter dem Hängeschrank.', opts:[
    {v:'ja', l:'Ja, kopfüber hängend', d:'an einer Metall-Leiste'},
    {v:'nein', l:'Nein, stehend', d:'auf Flexigel-Untersetzern'}]},
  {id:'leiste', when:()=>hasG() && gt() && A.kopfueber==='ja' && units()===2,
    q:'Welche Leisten passen besser in deinen Schrank?',
    hint:()=>`Für ${gtCount()} Gläser und Tassen brauchst du 50 cm Leistenlänge.`, opts:[
    {v:'2x25', l:'2 × 25 cm', d:'zwei getrennte Plätze'},
    {v:'1x50', l:'1 × 50 cm', d:'eine durchgehende Fläche'}]},
  {id:'stehend', when:()=>hasG() && gt() && A.kopfueber==='nein',
    q:'Wie sollen Gläser und Tassen stehen?', opts:[
    {v:'einzeln', l:'Einzeln auf Untersetzern', d:'Jedes Glas hat seinen eigenen Platz.'},
    {v:'reihe', l:'In einer Reihe auf einer Flexigel-Leiste', d:'Platzsparend im Schrank oder Regal.'}]},
  {id:'tellermaterial', when:()=>hasG() && has('geschirr','teller') && A.magnetgeschirr==='nachruesten',
    q:'Aus welchem Material sind deine Teller?', opts:[
    {v:'keramik', l:'Keramik oder Porzellan mit Standring'},
    {v:'kunststoff', l:'Kunststoff oder Melamin ohne Rand'}]},
  {id:'pfannenAnzahl', count:true, when:()=>hasG() && has('geschirr','pfannen'),
    q:'Wie viele Pfannen und Töpfe lassen sich ineinander stapeln?'},
  {id:'pfannenMagnet', when:()=>hasG() && has('geschirr','pfannen'),
    q:'Sind deine Pfannen und Töpfe induktionsgeeignet?',
    hint:'Schneller Test: Haftet ein Kühlschrankmagnet am Boden, sind sie magnetisch.', opts:[
    {v:'ja', l:'Ja, induktionsgeeignet'},
    {v:'nein', l:'Nein'},
    {v:'unklar', l:'Weiß ich nicht'}]},
  {id:'haengen', multi:true, when:hasH, q:'Was möchtest du aufhängen?', hint:'Mehrfachauswahl möglich.', opts:[
    {v:'jacken', l:'Jacken'},
    {v:'handtuecher', l:'Handtücher'},
    {v:'kuechenrolle', l:'Küchenrolle'},
    {v:'toilettenpapier', l:'Toilettenpapier'},
    {v:'licht', l:'Licht'}]},
  {id:'licht', when:()=>hasH() && has('haengen','licht'), q:'Welches Licht suchst du?', opts:[
    {v:'tisch', l:'Tischleuchte', d:'steht magnetisch auf dem Tisch'},
    {v:'spot', l:'Leucht-Spot', d:'haftet an Wand oder Möbeln'}]},
  {id:'careFuer', when:care, q:'Für wen suchst du eine Lösung?', opts:[
    {v:'selbst', l:'Für mich selbst'},
    {v:'angehoerig', l:'Für einen Angehörigen'},
    {v:'einrichtung', l:'Für eine Pflegeeinrichtung', d:'Mehrere Tische oder Tabletts'}]},
  {id:'careSituation', multi:true, when:care, q:'Was erschwert das Essen und Trinken?',
    hint:'Mehrfachauswahl möglich. Diese Angabe dient nur der Empfehlung und wird nicht gespeichert.', opts:[
    {v:'zittern', l:'Zittern oder eine unsichere Hand', d:'am Esstisch'},
    {v:'rollstuhl', l:'Essen am Rollstuhltisch oder Tablett'},
    {v:'bett', l:'Essen im Bett', d:'auf einem Tablett'}]},
  {id:'careGeschirr', multi:true, when:care, q:'Welches Geschirr soll sicher stehen?', hint:'Mehrfachauswahl möglich.', opts:[
    {v:'becher', l:'Becher, Tassen und Gläser'},
    {v:'teller', l:'Teller'},
    {v:'bowls', l:'Bowls und Schüsseln'}]},
  {id:'careTische', count:true, max:99, when:()=>einr() && sit('zittern'),
    q:'Wie viele Plätze am Esstisch sollen ausgestattet werden?', note:'Jeder Platz erhält ein eigenes Gedeck.'},
  {id:'careTabletts', count:true, max:99, when:()=>einr() && (sit('rollstuhl')||sit('bett')),
    q:'Wie viele Tabletts oder Rollstuhltische sollen ausgestattet werden?', note:'Jedes Tablett erhält ein Platzset und ein eigenes Gedeck.'},
  {id:'zhWichtig', multi:true, when:zh, q:'Was soll deine Lösung können?', hint:'Mehrfachauswahl möglich.', opts:[
    {v:'ohneBohren', l:'Ohne Bohren halten', d:'Ideal für Mietwohnung und Fliesen'},
    {v:'flexibel', l:'Flexibel umhängen', d:'Rückstandsfrei lösen und neu platzieren'}]},
  {id:'zhRaeume', multi:true, when:zh, q:'In welchen Räumen möchtest du etwas aufhängen oder befestigen?', hint:'Mehrfachauswahl möglich.', opts:[
    {v:'kueche', l:'Küche'},
    {v:'bad', l:'Bad'},
    {v:'flur', l:'Flur und Eingang'},
    {v:'wohnen', l:'Wohn- und Arbeitsbereich'}]},
  {id:'zhKuecheZettel', count:true, max:50, when:()=>zr('kueche'),
    q:'Wie viele Utensilien und Zettel möchtest du in der Küche befestigen?', note:'Ein Set enthält 4 Magnet-Pins inklusive Pads.'},
  {id:'zhBad', multi:true, when:()=>zr('bad'), q:'Was möchtest du im Bad unterbringen?', hint:'Mehrfachauswahl möglich.', opts:[
    {v:'flaschen', l:'Shampoo und Duschgel', d:'Flaschen hängen kopfüber an der Wand'},
    {v:'handtuecher', l:'Handtücher'},
    {v:'klein', l:'Kleinteile'}]},
  {id:'zhFlaschen', count:true, max:50, when:()=>zr('bad') && zi('zhBad','flaschen'),
    q:'Wie viele Flaschen möchtest du im Bad aufhängen?', note:'Jedes Set nimmt 2 Flaschen auf.'},
  {id:'zhFlaschenArt', when:()=>zr('bad') && zi('zhBad','flaschen') && exists('magspike') && exists('refillduo'), q:'Wie sollen deine Flaschen hängen?', opts:[
    {v:'refill', l:'In nachfüllbaren Flaschen', d:'Magnet-RefillDuo: 2 Flaschen à 250 ml, einfach umfüllen'},
    {v:'magspike', l:'In der Originalflasche', d:'MagSpike®: Magnet wird in die vorhandene Flasche gedrückt'}]},
  {id:'zhHandtuecher', count:true, max:50, when:()=>zr('bad') && zi('zhBad','handtuecher'),
    q:'Wie viele Handtücher sollen gleichzeitig hängen?', note:'Pro Handtuch ein Magnet-Haken »Hold On«.'},
  {id:'zhBadKlein', count:true, max:50, when:()=>zr('bad') && zi('zhBad','klein'),
    q:'Wie viele Kleinteile möchtest du im Bad befestigen?', note:'Ein Set enthält 4 Magnet-Pins inklusive Pads.'},
  {id:'zhFlur', multi:true, when:()=>zr('flur'), q:'Was möchtest du im Flur und Eingang aufhängen?', hint:'Mehrfachauswahl möglich.', opts:[
    {v:'schluessel', l:'Schlüssel'},
    {v:'jacken', l:'Jacken'},
    {v:'zettel', l:'Zettel und Post'},
    {v:'deko', l:'Deko bis 1 kg'}]},
  {id:'zhSchluessel', count:true, max:50, when:()=>zr('flur') && zi('zhFlur','schluessel'),
    q:'Wie viele Schlüsselbunde möchtest du aufhängen?', note:'Ein Set enthält 3 Magnet-Schlüsselringe.'},
  {id:'zhJacken', count:true, max:50, when:()=>zr('flur') && zi('zhFlur','jacken'),
    q:'Wie viele Jacken sollen gleichzeitig hängen?', note:'Eine Garderobe »Hold On« hat 2 Haken.'},
  {id:'zhFlurZettel', count:true, max:50, when:()=>zr('flur') && zi('zhFlur','zettel'),
    q:'Wie viele Zettel und Briefe möchtest du im Flur befestigen?', note:'Ein Set enthält 4 Magnet-Pins inklusive Pads.'},
  {id:'zhDeko', count:true, max:50, when:()=>zr('flur') && zi('zhFlur','deko'),
    q:'Wie viele Deko-Stücke möchtest du aufhängen?', note:'Pro Stück ein Magnet-Haken »Hold On«. Jedes Stück darf bis 1 kg wiegen.'},
  {id:'zhWohnen', multi:true, when:()=>zr('wohnen'), q:'Was möchtest du im Wohn- und Arbeitsbereich befestigen?', hint:'Mehrfachauswahl möglich.', opts:[
    {v:'notizen', l:'Notizen und Fotos'},
    {v:'kabel', l:'Kabel und Kleinteile'},
    {v:'licht', l:'Licht'}]},
  {id:'zhNotizen', count:true, max:50, when:()=>zr('wohnen') && zi('zhWohnen','notizen'),
    q:'Wie viele Notizen und Fotos möchtest du befestigen?', note:'Ein Set enthält 4 Magnet-Pins inklusive Pads.'},
  {id:'zhKabel', count:true, max:50, when:()=>zr('wohnen') && zi('zhWohnen','kabel'),
    q:'Wie viele Kabel und Kleinteile möchtest du befestigen?', note:'Ein Set enthält 4 Magnet-Pins inklusive Pads.'},
  {id:'zhLicht', when:()=>zr('wohnen') && zi('zhWohnen','licht'), q:'Welches Licht suchst du?', opts:[
    {v:'tisch', l:'Tischleuchte', d:'steht magnetisch auf Tisch oder Regal'},
    {v:'spot', l:'Leucht-Spot', d:'haftet an Wand oder Möbeln'}]},
  {id:'zhLichtAnzahl', count:true, max:20, when:()=>zr('wohnen') && zi('zhWohnen','licht'),
    q:'Wie viele Leuchten möchtest du?', note:'Kabellos, ohne Bohren.'},
  {id:'farbe', when:()=>calc().some(l=>PRODUCTS[l.key] && PRODUCTS[l.key].v.weiss), q:'Welche Farbe passt zu deinem Innenraum?', opts:[
    {v:'schwarz', l:'Schwarz'},
    {v:'weiss', l:'Weiß'}]}
];

/* ---------- Texte und Bilder aus dem Theme-Editor ---------- */
const LBL = Object.assign({next:'Weiter', back:'Zurück', cart:'In den Warenkorb', change:'Antwort ändern', restart:'Neu starten', step:'Frage {n} von {t}', result:'Deine Empfehlung'}, CFG.labels||{});
Object.keys(LBL).forEach(k=>{ if(!LBL[k]) delete LBL[k]; });
const DEF_LBL = {next:'Weiter', back:'Zurück', cart:'In den Warenkorb', change:'Antwort ändern', restart:'Neu starten', step:'Frage {n} von {t}', result:'Deine Empfehlung'};
const L = k => LBL[k] || DEF_LBL[k];
const IMG_SHAPE = CFG.imageShape || 'round';
(CFG.blocks||[]).forEach(b=>{
  if(!b || !b.target) return;
  if(b.type==='question'){
    const st = STEPS.find(x=>x.id===b.target); if(!st) return;
    if(b.title) st.q = b.title;
    if(b.desc) st.hint = b.desc;
  } else if(b.type==='answer'){
    const [sid, val] = b.target.split(':');
    const st = STEPS.find(x=>x.id===sid); if(!st || !st.opts) return;
    const o = st.opts.find(x=>x.v===val); if(!o) return;
    if(b.title) o.l = b.title;
    if(b.desc) o.d = b.desc;
    if(b.image){ o.img = b.image; o.alt = b.alt || ''; o.shape = (b.shape && b.shape!=='default') ? b.shape : IMG_SHAPE; }
  }
});

const stepById = id => STEPS.find(s=>s.id===id);
const isActive = s => !s.when || s.when();
const activeSteps = () => STEPS.filter(isActive);

function nextId(fromId){
  const i = STEPS.findIndex(s=>s.id===fromId);
  for(let j=i+1;j<STEPS.length;j++){ if(isActive(STEPS[j])) return STEPS[j].id; }
  return 'result';
}
function go(){
  history.push(cur);
  cur = nextId(cur);
  if(cur==='result'){ lines = calc(); }
  render(true);
}
function back(){
  if(!history.length) return;
  cur = history.pop();
  render(true);
}
function restart(){ A={}; history=[]; cur='bereich'; lines=[]; lead={kontakt:'video'}; leadSent=false; render(true); }

/* ---------- Mengenlogik ---------- */
function ans(id){ const s=stepById(id); return isActive(s) ? A[id] : undefined; }

function calc(){
  const out = [];
  const add = (key, qty, reason) => { if(qty>0 && exists(key)) out.push({key, qty, reason}); };
  const p = P();

  if(ans('masse')==='ueber35'){
    add('angles',1,'Über 3,5 t: Toter-Winkel-Hinweise sind in Frankreich Pflicht. Abwählbar, falls du nicht nach Frankreich fährst.');
  }

  if(hasG() && Array.isArray(A.geschirr)){
    const nach = ans('magnetgeschirr')==='nachruesten';
    let padS = 0, padM = 0; const sWhy=[], mWhy=[];
    const n = gtCount();

    if(gt()){
      if(ans('kopfueber')==='ja'){
        const u = units();
        let f50 = Math.floor(u/2), f25 = u%2;
        if(u===2 && ans('leiste')==='2x25'){ f50=0; f25=2; }
        add('metall50', f50, `Für ${n} Gläser und Tassen kopfüber (je 25 cm bis zu 4 Stück)`);
        add('metall25', f25, `Für ${n} Gläser und Tassen kopfüber (je 25 cm bis zu 4 Stück)`);
        if(nach){ padS += n; sWhy.push(`${n} × Gläser/Tassen`); }
      } else if(ans('stehend')==='reihe'){
        const u = units();
        add('flex51', Math.floor(u/2), `Für ${n} Gläser und Tassen in einer Reihe (51 cm bis zu 8 Stück)`);
        add('flex26', u%2, `Für ${n} Gläser und Tassen in einer Reihe (26 cm bis zu 4 Stück)`);
        if(nach){ padS += n; sWhy.push(`${n} × Gläser/Tassen`); }
      } else {
        if(nach){
          add('bundle2', Math.floor(n/2), `Untersetzer und Pad für ${n} Gläser und Tassen`);
          add('bundle1', n%2, 'Für das letzte einzelne Glas');
        } else {
          add('untersetzer', n, `Gegenseite für ${n} magnetische Gläser und Tassen`);
        }
      }
    }
    if(has('geschirr','teller') && nach){
      if(ans('tellermaterial')==='kunststoff'){ padM += p; mWhy.push(`${p} × Teller`); }
      else { padS += p; sWhy.push(`${p} × Teller mit Standring`); }
    }
    if(has('geschirr','bowls') && nach){ padM += p; mWhy.push(`${p} × Bowls`); }

    add('padS', Math.ceil(padS/2), `${padS} ${padS===1?'Pad':'Pads'} für ${sWhy.join(', ')} · 2 Pads je Set`);
    add('padM', Math.ceil(padM/2), `${padM} ${padM===1?'Pad':'Pads'} für ${mWhy.join(', ')} · 2 Pads je Set`);

    let needPlatzset = has('geschirr','teller') || has('geschirr','bowls');
    if(has('geschirr','pfannen')){
      const pm = ans('pfannenMagnet');
      const cnt = Number(A.pfannenAnzahl||1);
      if(pm==='ja'){
        add('stapelset', Math.ceil(cnt/3), `${cnt} stapelbare Pfannen/Töpfe · 3 Stapelpads je Set`);
        needPlatzset = true;
      }
    }
    if(needPlatzset) add('platzset',1,'Rutschfeste Fläche für Teller, Bowls und Pfannen');
  }

  if(care() && Array.isArray(A.careGeschirr) && Array.isArray(A.careSituation) && A.careSituation.length){
    const e = einr();
    const T = sit('zittern') ? (e ? Number(A.careTische||1) : 1) : 0;
    const B = e ? ((sit('rollstuhl')||sit('bett')) ? Number(A.careTabletts||1) : 0)
                : (sit('rollstuhl')?1:0) + (sit('bett')?1:0);
    const g = v => has('careGeschirr', v);
    const tl = n => `${n} ${n===1?'Tablett':'Tabletts'}`;
    const pl = n => `${n} ${n===1?'Platz':'Plätze'}`;
    let padS=0, padM=0; const sWhy=[], mWhy=[];
    if(g('becher')){
      if(T){ add('bundle2', Math.floor(T/2), `Untersetzer und Pad für Becher an ${T} ${T===1?'Platz':'Plätzen'} am Esstisch`);
             add('bundle1', T%2, T>1 ? 'Für den letzten einzelnen Platz' : 'Untersetzer und Pad für den Becher am Esstisch'); }
      if(B){ padS += B; sWhy.push(`Becher auf ${tl(B)}`); }
    }
    const places = T + B;
    if(g('teller')){ padM += places; mWhy.push(`${places} × Teller`); }
    if(g('bowls')){ padM += places; mWhy.push(`${places} × Bowls`); }
    add('padS', Math.ceil(padS/2), `${padS} ${padS===1?'Pad':'Pads'} für ${sWhy.join(', ')} · 2 Pads je Set`);
    add('padM', Math.ceil(padM/2), `${padM} ${padM===1?'Pad':'Pads'} für ${mWhy.join(', ')} · 2 Pads je Set`);
    const psT = (g('teller')||g('bowls')) ? T : 0;
    add('platzset', psT + B, [psT?`${pl(psT)} am Esstisch`:'', B?`${tl(B)}`:''].filter(Boolean).join(' und ') + ': je ein Platzset als rutschfeste Fläche');
  }

  if(zh() && Array.isArray(A.zhRaeume)){
    const n = id => Number(ans(id)||0);
    const pinParts = [['zhKuecheZettel','Küche'],['zhBadKlein','Bad'],['zhFlurZettel','Flur'],['zhNotizen','Notizen/Fotos'],['zhKabel','Kabel/Kleinteile']]
      .filter(([id])=>n(id)).map(([id,l])=>[n(id),l]);
    const pinSum = pinParts.reduce((a,[c])=>a+c,0);
    add('pins', Math.ceil(pinSum/4), `${pinSum} ${pinSum===1?'Pin':'Pins'} (${pinParts.map(([c,l])=>`${l} ${c}`).join(', ')}) · 4 Pins je Set`);
    const fl = n('zhFlaschen'), flTxt = `${fl} ${fl===1?'Flasche':'Flaschen'} im Bad`;
    if(ans('zhFlaschenArt')==='magspike' || !exists('refillduo')) add('magspike', Math.ceil(fl/2), `${flTxt} · 2 MagSpikes je Set`);
    else add('refillduo', Math.ceil(fl/2), `${flTxt} · 2 Nachfüllflaschen je Set`);
    const hk = n('zhHandtuecher') + n('zhDeko');
    add('haken', hk, [n('zhHandtuecher')?`${n('zhHandtuecher')} ${n('zhHandtuecher')===1?'Handtuch':'Handtücher'}`:'', n('zhDeko')?`${n('zhDeko')} ${n('zhDeko')===1?'Deko-Stück':'Deko-Stücke'}`:''].filter(Boolean).join(' und ') + ' · 1 Haken je Stück');
    add('schluessel', Math.ceil(n('zhSchluessel')/3), `${n('zhSchluessel')} ${n('zhSchluessel')===1?'Schlüsselbund':'Schlüsselbunde'} · 3 Ringe je Set`);
    add('garderobe', Math.ceil(n('zhJacken')/2), `${n('zhJacken')} ${n('zhJacken')===1?'Jacke':'Jacken'} · 2 Haken je Garderobe`);
    if(n('zhLichtAnzahl')) add(ans('zhLicht')==='spot'?'spot':'leuchte', n('zhLichtAnzahl'), 'Kabellos, ohne Bohren');
  }

  if(hasH() && Array.isArray(A.haengen)){
    if(has('haengen','jacken')) add('garderobe', Math.ceil(p/2), `Je Garderobe 2 Haken für ${p} ${p===1?'Person':'Personen'}`);
    if(has('haengen','handtuecher')) add('haken', p, `Ein Haken pro Person`);
    if(has('haengen','kuechenrolle')) add('kuechenrolle',1,'Für die Küchenzeile');
    if(has('haengen','toilettenpapier')) add('toilette',1,'Für das Bad');
    if(has('haengen','licht')) add(ans('licht')==='spot'?'spot':'leuchte',1,'Kabellos, ohne Bohren');
  }
  return out;
}

function resultNotes(){
  const n=[];
  const color = (ans('farbe')||'schwarz');
  if(ans('masse')==='unklar') n.push('Liegt dein Fahrzeug über 3,5 t, brauchst du in Frankreich Toter-Winkel-Hinweise. Die Angles-Morts-Pads findest du im Shop.');
  if(ans('pfannenMagnet')==='nein') n.push('Deine Pfannen und Töpfe sind nicht magnetisch. Die Stapelpads halten daran nicht, deshalb empfehlen wir hier nichts.');
  if(ans('pfannenMagnet')==='unklar') n.push('Prüfe deine Pfannen mit einem Kühlschrankmagneten. Nur wenn er haftet, halten die Stapelpads. Wir haben das Stapelset deshalb noch nicht eingeplant.');
  if(lines.some(l=>l.key==='padS')) n.push('Klebepunkte für besonders starken Halt liegen jedem MagUp-Pad S bei.');
  if(color==='weiss' && lines.some(l=>!PRODUCTS[l.key].v.weiss && !PRODUCTS[l.key].fixed)) n.push('Einige Artikel gibt es nur in Schwarz. Sie sind entsprechend markiert.');
  return n;
}

/* ---------- Kundenkonto-Attribute ---------- */
function attributes(){
  const map = {
    beratung_bereich:'bereich', beratung_fahrzeug:'fahrzeug', beratung_bootstyp:'bootstyp', beratung_glaeser_stehend:'stehend', beratung_gesamtmasse:'masse',
    beratung_personen:'personen', beratung_ziel:'ziel', beratung_magnetgeschirr:'magnetgeschirr',
    beratung_geschirr:'geschirr', beratung_kopfueber:'kopfueber', beratung_leisten:'leiste',
    beratung_tellermaterial:'tellermaterial', beratung_pfannen_anzahl:'pfannenAnzahl',
    beratung_pfannen_magnetisch:'pfannenMagnet', beratung_aufhaengen:'haengen',
    beratung_licht:'licht', beratung_farbe:'farbe',
    beratung_care_fuer:'careFuer', beratung_care_geschirr:'careGeschirr',
    beratung_care_tische:'careTische', beratung_care_tabletts:'careTabletts'
  };
  const o = {};
  for(const [k,id] of Object.entries(map)){
    const v = ans(id);
    if(v!==undefined && v!=='' && !(Array.isArray(v)&&!v.length)) o[k] = Array.isArray(v)? v.join(', ') : String(v);
  }
  if(care() && !einr()){
    const t = sit('zittern')?1:0, b=(sit('rollstuhl')?1:0)+(sit('bett')?1:0);
    if(t) o.beratung_care_tische='1'; if(b) o.beratung_care_tabletts=String(b);
  }
  if(zh()){
    const w = ans('zhWichtig'); if(Array.isArray(w)&&w.length) o.beratung_zh_wichtig = w.join(', ');
    const r = ans('zhRaeume'); if(Array.isArray(r)&&r.length) o.beratung_zh_raeume = r.join(', ');
    const m = [['zhKuecheZettel','kueche_zettel'],['zhFlaschen','flaschen'],['zhHandtuecher','handtuecher'],['zhBadKlein','bad_kleinteile'],['zhSchluessel','schluessel'],['zhJacken','jacken'],['zhFlurZettel','flur_zettel'],['zhDeko','deko'],['zhNotizen','notizen'],['zhKabel','kabel'],['zhLichtAnzahl','leuchten']]
      .filter(([id])=>ans(id)).map(([id,k])=>`${k}:${ans(id)}`);
    if(m.length) o.beratung_zh_mengen = m.join('; ');
    if(ans('zhLicht')) o.beratung_zh_licht = ans('zhLicht');
    if(ans('zhFlaschenArt')) o.beratung_zh_flaschen_art = ans('zhFlaschenArt');
  }
  o.beratung_version = 'v7';
  return o;
}

async function addToCart(btn){
  const items = lines.filter(l=>l.qty>0).map(l=>({id:variantOf(l.key), quantity:l.qty}));
  if(!items.length) return;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const msg = ROOT.querySelector('#gm-cart-msg');
  btn.disabled = true; btn.textContent = 'Wird hinzugefügt …';
  try{
    const r = await fetch(root+'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items})});
    if(!r.ok){ const e = await r.json().catch(()=>({})); throw new Error(e.description || 'Die Artikel konnten nicht in den Warenkorb gelegt werden.'); }
    const cart = await fetch(root+'cart.js').then(x=>x.json()).catch(()=>({attributes:{}}));
    const attrs = attributes();
    for(const k of Object.keys(cart.attributes||{})){ if(k.startsWith('beratung_') && !(k in attrs)) attrs[k]=''; }
    await fetch(root+'cart/update.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({attributes:attrs})});
    window.location.href = root+'cart';
  }catch(err){
    btn.disabled = false; btn.textContent = L('cart');
    if(msg) msg.textContent = err.message;
  }
}

/* ---------- Rendering ---------- */
const app = ROOT ? ROOT.querySelector('#gm-berater-app') : null;
const fmt = n => n.toLocaleString('de-DE',{style:'currency',currency:'EUR'});
const esc = s => String(s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));

function render(focus){
  if(window.Shopify && Shopify.designMode) window.__gmBerater = {A, history, cur};
  if(cur==='result'){ renderResult(); }
  else { renderStep(stepById(cur)); }
  if(focus){ const h=app.querySelector('h1'); if(h){ h.setAttribute('tabindex','-1'); h.focus({preventScroll:true}); } ROOT.scrollIntoView({block:'start', behavior:'smooth'}); }
}

function renderStep(s){
  const act = activeSteps();
  const idx = act.findIndex(x=>x.id===s.id);
  const pct = Math.round((idx)/(act.length)*100);
  const hint = typeof s.hint==='function' ? s.hint() : s.hint;
  let body = '';

  if(s.count){
    if(!A[s.id]) A[s.id]=1;
    const note = s.note || 'Ein Stapelset sichert bis zu 3 ineinander gestapelte Pfannen oder Töpfe.';
    body = `<div class="counter">
      <button class="round" data-c="-1" aria-label="Weniger">−</button>
      <input id="cnt" class="cnt" type="number" inputmode="numeric" min="1" max="${s.max||9}" value="${A[s.id]}" aria-label="Anzahl">
      <button class="round" data-c="1" aria-label="Mehr">+</button></div>
      <p class="hint" style="text-align:center">${esc(note)}</p>`;
  } else {
    const sel = A[s.id];
    body = `<div class="opts ${s.grid?'grid':''}" role="group">` + s.opts.map(o=>{
      const on = s.multi ? (Array.isArray(sel)&&sel.includes(o.v)) : sel===o.v;
      return `<button class="opt ${s.multi?'multi':''} ${o.img?'has-img':''}" data-v="${o.v}" aria-pressed="${on}" ${o.off?'disabled':''}>
        <span class="mark" aria-hidden="true"></span>
        <span class="ot"><b>${esc(o.l)}</b>${o.d?`<span class="d">${esc(o.d)}</span>`:''}</span>
        ${o.img?`<img class="opt-img shape-${esc(o.shape)}" src="${esc(o.img)}" alt="${esc(o.alt)}" loading="lazy" width="120" height="120">`:''}</button>`;
    }).join('') + `</div>`;
  }

  const needNext = s.multi || s.count;
  const canNext = s.count || (Array.isArray(A[s.id]) && A[s.id].length);
  app.innerHTML = `
    <div class="track" aria-hidden="true"><i style="width:${pct}%"></i></div>
    <p class="step-no">${esc(L('step').replace('{n}',idx+1).replace('{t}',act.length))}</p>
    <h1>${esc(s.q)}</h1>
    ${hint?`<p class="hint">${esc(hint)}</p>`:''}
    ${body}
    <div class="nav">
      ${history.length?`<button class="link" id="back">${esc(L('back'))}</button>`:'<span></span>'}
      ${needNext?`<button class="btn" id="next" ${canNext?'':'disabled'}>${esc(L('next'))}</button>`:''}
    </div>`;

  app.querySelectorAll('.opt').forEach(b=>b.addEventListener('click',()=>{
    const v=b.dataset.v;
    if(s.multi){
      const arr = Array.isArray(A[s.id])?[...A[s.id]]:[];
      const i = arr.indexOf(v); i>-1?arr.splice(i,1):arr.push(v);
      A[s.id]=arr; renderStep(s);
    } else { A[s.id]=v; renderStep(s); setTimeout(go,160); }
  }));
  const mx = s.max||9, clamp = v => Math.min(mx,Math.max(1,Math.round(Number(v)||1)));
  app.querySelectorAll('[data-c]').forEach(b=>b.addEventListener('click',()=>{
    A[s.id]=clamp(A[s.id]+Number(b.dataset.c));
    app.querySelector('#cnt').value=A[s.id];
  }));
  const ci = app.querySelector('#cnt');
  if(ci) ci.addEventListener('change',()=>{ A[s.id]=clamp(ci.value); ci.value=A[s.id]; });
  const nb=app.querySelector('#next'); if(nb) nb.addEventListener('click',go);
  const bb=app.querySelector('#back'); if(bb) bb.addEventListener('click',back);
}

const LEAD_FIELDS = [
  {id:'firma', l:'Name der Einrichtung', req:true, full:true, ac:'organization'},
  {id:'strasse', l:'Straße und Hausnummer', req:true, full:true, ac:'street-address'},
  {id:'plz', l:'PLZ', req:true, ac:'postal-code', im:'numeric'},
  {id:'ort', l:'Ort', req:true, ac:'address-level2'},
  {id:'vorname', l:'Vorname Ansprechpartner/in', req:true, ac:'given-name'},
  {id:'nachname', l:'Nachname', req:true, ac:'family-name'},
  {id:'tel', l:'Telefon', req:true, type:'tel', ac:'tel'},
  {id:'mail', l:'E-Mail', req:true, type:'email', ac:'email'},
  {id:'url', l:'Website der Einrichtung', type:'url', full:true, ph:'https://', ac:'url'}
];

function leadHtml(){
  if(leadSent){
    return `<section class="lead" aria-labelledby="lead-h">
      <h2 id="lead-h" tabindex="-1">Danke, Ihre Anfrage ist bei uns</h2>
      <div class="sent">Wir erstellen ein Angebot auf Basis der Ausstattung oben und melden uns bei ${esc((lead.vorname||'')+' '+(lead.nachname||''))}, um ${lead.kontakt==='video'?'einen Videocall':'ein persönliches Gespräch'} zu vereinbaren.</div>
    </section>`;
  }
  return `<section class="lead" aria-labelledby="lead-h">
    <h2 id="lead-h">Lassen Sie uns persönlich sprechen</h2>
    <p>Jede Einrichtung ist anders. Gern besprechen wir Ihre Anforderungen in einem unverbindlichen Beratungsgespräch, persönlich oder per Videocall. Mit Ihren Kontaktdaten erstellen wir vorab ein passendes Angebot.</p>
    <form id="leadForm" novalidate>
      <div class="fields">
        ${LEAD_FIELDS.map(f=>`<div class="f ${f.full?'full':''}">
          <label for="l-${f.id}">${f.l}${f.req?'':' (optional)'}</label>
          <input id="l-${f.id}" name="${f.id}" type="${f.type||'text'}" autocomplete="${f.ac||'off'}" ${f.im?`inputmode="${f.im}"`:''} ${f.ph?`placeholder="${f.ph}"`:''} ${f.req?'required':''} value="${esc(lead[f.id]||'')}" aria-describedby="e-${f.id}">
          <span class="err" id="e-${f.id}"></span></div>`).join('')}
        <div class="f full"><span class="f"><span style="display:block;font-size:.88rem;font-weight:500;margin-bottom:4px">Gewünschtes Gespräch</span></span>
          <div class="choice" role="radiogroup" aria-label="Gewünschtes Gespräch">
            <label><input type="radio" name="kontakt" value="video" ${lead.kontakt==='video'?'checked':''}> Videocall</label>
            <label><input type="radio" name="kontakt" value="persoenlich" ${lead.kontakt==='persoenlich'?'checked':''}> Persönlich vor Ort</label>
          </div></div>
        <div class="f full"><label for="l-notiz">Anmerkungen (optional)</label>
          <textarea id="l-notiz" name="notiz" rows="3" placeholder="z. B. Anzahl der Wohnbereiche, Wunschtermin">${esc(lead.notiz||'')}</textarea></div>
        <div class="full">
          <label class="consent"><input type="checkbox" id="l-consent" ${lead.consent?'checked':''}>
          <span>Ich bin einverstanden, dass gelmags® meine Angaben zur Bearbeitung dieser Anfrage verarbeitet. Details in der <a href="${(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/'}policies/privacy-policy" target="_blank" rel="noopener">Datenschutzerklärung</a>.</span></label>
          <span class="err" id="e-consent"></span>
        </div>
      </div>
      <p class="err" id="e-send" role="alert"></p>
      <div class="cta"><button class="btn" type="submit" id="lead-submit">Beratung anfragen</button></div>
    </form>
  </section>`;
}

function bindLead(){
  const f = app.querySelector('#leadForm'); if(!f) return;
  f.addEventListener('input', e=>{
    const t=e.target;
    if(t.name==='kontakt') lead.kontakt=t.value;
    else if(t.id==='l-consent') lead.consent=t.checked;
    else if(t.name) lead[t.name]=t.value;
  });
  f.addEventListener('submit', e=>{
    e.preventDefault();
    let first=null;
    const setErr=(id,msg)=>{ const el=app.querySelector('#e-'+id); if(el) el.textContent=msg||''; const inp=app.querySelector('#l-'+id); if(inp) inp.setAttribute('aria-invalid', msg?'true':'false'); if(msg && !first) first=inp; };
    LEAD_FIELDS.forEach(fd=>{
      const v=(lead[fd.id]||'').trim();
      let msg='';
      if(fd.req && !v) msg='Bitte ausfüllen.';
      else if(fd.type==='email' && v && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) msg='Bitte eine gültige E-Mail-Adresse eingeben.';
      else if(fd.id==='plz' && v && !/^\d{4,5}$/.test(v)) msg='Bitte eine gültige PLZ eingeben.';
      else if(fd.type==='url' && v && !/^https?:\/\/\S+\.\S+/.test(v)) msg='Bitte die Adresse mit https:// angeben.';
      setErr(fd.id,msg);
    });
    const ce=app.querySelector('#e-consent');
    if(!lead.consent){ ce.textContent='Bitte bestätigen Sie die Einwilligung.'; if(!first) first=app.querySelector('#l-consent'); } else ce.textContent='';
    if(first){ first.focus(); return; }
    const sb = app.querySelector('#lead-submit'), se = app.querySelector('#e-send');
    sb.disabled = true; sb.textContent = 'Wird gesendet …'; se.textContent = '';
    sendLead().then(()=>{
      leadSent=true; renderResult();
      const h=app.querySelector('#lead-h'); if(h) h.focus();
    }).catch(err=>{
      sb.disabled=false; sb.textContent='Beratung anfragen';
      se.textContent = 'Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut.';
      console.error(err);
    });
  });
}

async function sendLead(){
  const hs = CFG.hubspot || {};
  if(!hs.portal || !hs.form) throw new Error('HubSpot-Formular ist nicht konfiguriert.');
  const p = leadPayload();
  const cookie = (document.cookie.match(/(?:^|; )hubspotutk=([^;]+)/)||[])[1];
  const message = ['Gewünschtes Gespräch: '+(p.gespraech==='video'?'Videocall':'persönlich vor Ort'), p.anmerkung?'Anmerkung: '+p.anmerkung:'', 'Ausstattung laut Produktberater: '+p.ausstattung].filter(Boolean).join('\n');
  const fields = [
    ['company',p.firma],['address',p.strasse],['zip',p.plz],['city',p.ort],
    ['firstname',lead.vorname],['lastname',lead.nachname],['phone',p.telefon],['email',p.email],
    ['website',p.website],['message',message]
  ].filter(([,v])=>v).map(([name,value])=>({objectTypeId:'0-1', name, value:String(value)}));
  const body = {
    fields,
    context: Object.assign({pageUri: location.href, pageName: document.title}, cookie?{hutk:cookie}:{}),
    legalConsentOptions: {consent:{consentToProcess:true, text:'Ich bin einverstanden, dass gelmags® meine Angaben zur Bearbeitung dieser Anfrage verarbeitet.'}}
  };
  const r = await fetch('https://api.hsforms.com/submissions/v3/integration/submit/'+encodeURIComponent(hs.portal)+'/'+encodeURIComponent(hs.form),
    {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(body)});
  if(!r.ok) throw new Error('HubSpot '+r.status+': '+(await r.text()));
}

function leadPayload(){
  return {
    firma:lead.firma, strasse:lead.strasse, plz:lead.plz, ort:lead.ort,
    ansprechpartner:((lead.vorname||'')+' '+(lead.nachname||'')).trim(), telefon:lead.tel, email:lead.mail, website:lead.url||'',
    gespraech:lead.kontakt, anmerkung:lead.notiz||'',
    ausstattung: lines.filter(l=>l.qty).map(l=>`${l.qty} × ${PRODUCTS[l.key].name} (${colorOf(l.key)==='weiss'?'weiß':'schwarz'})`).join('; ')
  };
}

function zhIntro(){
  const w = Array.isArray(A.zhWichtig)?A.zhWichtig:[];
  if(w.includes('ohneBohren') && w.includes('flexibel')) return 'Alles hält ohne Bohren und lässt sich jederzeit rückstandsfrei neu platzieren.';
  if(w.includes('ohneBohren')) return 'Alles hält ohne Bohren, auch auf Fliesen und in der Mietwohnung.';
  if(w.includes('flexibel')) return 'Alles lässt sich jederzeit rückstandsfrei lösen und neu platzieren.';
  return 'Berechnet nach deinen Mengenangaben.';
}

function renderResult(){
  const color = (ans('farbe')||'schwarz');
  const total = lines.reduce((s,l)=>s+l.qty*priceOf(l.key),0);
  const notes = resultNotes();
  const attrs = attributes();
  const p = P();
  const careTitle = {selbst:'Deine Ausstattung für mehr Sicherheit beim Essen', angehoerig:'Die Ausstattung für deinen Angehörigen', einrichtung:'Die Ausstattung für eure Einrichtung'}[A.careFuer];
  const fz = A.bereich==='boot'
    ? ({segelboot:'dein Segelboot', motorboot:'dein Motorboot', hausboot:'dein Hausboot'}[A.bootstyp]||'dein Boot')
    : ({wohnwagen:'deinen Wohnwagen', wohnmobil:'dein Wohnmobil', camper:'deinen Camper'}[A.fahrzeug]||'deine Reise');

  const rows = lines.map((l,i)=>{
    const pr = PRODUCTS[l.key];
    const onlyBlack = color==='weiss' && !pr.v.weiss && !pr.fixed;
    const cName = colorOf(l.key)==='weiss' ? 'weiß' : 'schwarz';
    return `<li class="row ${l.qty?'':'off'}">
      <span class="n">${esc(pr.name)}, ${pr.label ? esc(pr.label[colorOf(l.key)]) : (onlyBlack?'schwarz (nur in Schwarz)':cName)}</span>
      <span class="p">${fmt(priceOf(l.key)*l.qty)}</span>
      <span class="r">${esc(l.reason)}</span>
      <span class="qty"><button data-i="${i}" data-d="-1" aria-label="Menge verringern">−</button><span>${l.qty}</span><button data-i="${i}" data-d="1" aria-label="Menge erhöhen">+</button></span>
    </li>`;
  }).join('');

  app.innerHTML = `
    <div class="track" aria-hidden="true"><i style="width:100%"></i></div>
    <p class="step-no">${esc(L('result'))}</p>
    <h1>${care() ? careTitle : zh() ? 'Deine Ausstattung für zuhause' : 'Deine Ausstattung für '+fz}</h1>
    <p class="hint">${care() ? 'Jeder Platz erhält ein eigenes Gedeck.' : zh() ? zhIntro() : `Berechnet für ${p} ${p===1?'Person':'Personen'}.`} Du kannst jede Menge anpassen.</p>
    ${lines.length ? `<ul class="list">${rows}</ul>
      <div class="sum"><span>Summe</span><strong>${fmt(total)}</strong></div>` :
      `<div class="empty">Für deine Auswahl gibt es noch keine passende Empfehlung. Geh zurück und ergänze, was du sichern möchtest.</div>`}
    ${notes.length?`<ul class="notes">${notes.map(n=>`<li>${esc(n)}</li>`).join('')}</ul>`:''}
    ${einr()?leadHtml():''}
    <p class="err" id="gm-cart-msg" role="alert"></p>
    <div class="cta">
      ${lines.some(l=>l.qty>0)?`<button class="btn ${einr()?'':'coral'}" id="gm-add">${einr()?'Direkt bestellen':esc(L('cart'))}</button>`:''}
      <button class="link" id="back">${esc(L('change'))}</button>
      <button class="link" id="restart">${esc(L('restart'))}</button>
    </div>
    ${DEBUG?`<details>
      <summary>Diese Angaben landen an der Bestellung (intern)</summary>
      <div class="attr"><table>${Object.entries(attrs).map(([k,v])=>`<tr><td>${k}</td><td>${esc(v)}</td></tr>`).join('')}</table></div>
    </details>`:''}
    ${DEBUG&&einr()&&leadSent?`<details open>
      <summary>An HubSpot übermittelt (intern)</summary>
      <div class="attr"><table>${Object.entries(leadPayload()).map(([k,v])=>`<tr><td>${k}</td><td>${esc(v)}</td></tr>`).join('')}</table></div>
    </details>`:''}`;
  bindLead();

  app.querySelectorAll('.qty button').forEach(b=>b.addEventListener('click',()=>{
    const l = lines[Number(b.dataset.i)];
    l.qty = Math.max(0, l.qty + Number(b.dataset.d));
    renderResult();
  }));
  app.querySelector('#back').addEventListener('click',back);
  app.querySelector('#restart').addEventListener('click',restart);
  const ab = app.querySelector('#gm-add'); if(ab) ab.addEventListener('click',()=>addToCart(ab));
}

if(!ROOT) return;
/* Im Theme-Editor den Stand beim Neuladen des Abschnitts behalten */
const DESIGN = !!(window.Shopify && Shopify.designMode);
if(DESIGN && window.__gmBerater){ const st=window.__gmBerater; A=st.A; history=st.history; cur=st.cur; lines=cur==='result'?calc():[]; }
render(false);
}
init();
document.addEventListener('shopify:section:load', e=>{ if(e.target && e.target.querySelector && e.target.querySelector('#gm-berater')) init(); });
})();
